// extracted by mini-css-extract-plugin
module.exports = {"carousel":"GlobalCarousel_carousel__SW8pn","tile":"GlobalCarousel_tile__H62tC","shimmer":"GlobalCarousel_shimmer__oi7ur","shine":"GlobalCarousel_shine__s_d_L"};